module.exports = __webpack_public_path__ + "img/背包十年.dc15e516.png";